export default {"src":"/_next/static/media/arrow-exp.f644605e.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};